import './add-address.scss';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { If, Then, Else } from 'react-if';
import PageHeader from '../../../shared/blocks/page-header/page-header';
import AddressForm from '../../../shared/forms/address-form';
import useGoogleAutocompleteScript from '../../../../utilities/hooks/useGoogleAutocompleteScript';
import useAddAddress from '../../../../utilities/hooks/useAddAddress';
import useSetPrimaryAddress from '../../../../utilities/hooks/useSetPrimaryAddress';
import useAddresses from '../../../../utilities/hooks/useAddresses';
import Loader from '../../../shared/blocks/loader/loader';

const AddAddress = () => {
  useGoogleAutocompleteScript();

  useAddresses();
  const navigate = useNavigate();
  const { profile, userAddressesFetched } = useSelector((state) => ({
    profile: state.accounts.user.profile,
    userAddressesFetched: state.accounts.userAddressesFetched,
  }));
  const { add: addAddress, isLoading } = useAddAddress();
  const { set: setPrimaryAddress } = useSetPrimaryAddress();

  const handleBack = useCallback(() => {
    navigate('/addresses');
  }, [navigate]);

  const handleSubmit = useCallback((address) => {
    const { isDefaultShippingAddress, ...payload } = address;
    addAddress({ ...payload, email: profile?.email }, {
      onSuccess: (data) => {
        if (isDefaultShippingAddress) {
          setPrimaryAddress(data.id, {
            onSuccess: handleBack,
          });
        } else {
          handleBack();
        }
      },
    });
  }, [addAddress, profile?.email, handleBack, setPrimaryAddress]);

  return (
    <div className="add-address-page">
      <PageHeader title="New address" />
      <If condition={userAddressesFetched}>
        <Then>
          <AddressForm
            onSubmit={handleSubmit}
            submitting={isLoading}
            onCancel={handleBack}
            defaultValues={{
              firstName: profile?.given_name ?? '',
              lastName: profile?.family_name ?? '',
              phone: profile?.phone_number ?? '',
            }}
          />
        </Then>
        <Else>
          <Loader />
        </Else>
      </If>
    </div>
  );
};

export default AddAddress;
